import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function AboutPage() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '哈哈漫画网的漫画是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的！哈哈漫画网上的所有漫画均可免费在线阅读，无需付费订阅。我们通过广告和会员增值服务维持运营，确保核心阅读功能对所有人开放。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画的更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '热门连载漫画通常每周更新一到两话，具体更新频率取决于韩国原作者的更新进度。我们会在漫画更新后的第一时间同步到平台。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些设备阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '哈哈漫画网支持全平台阅读，包括PC电脑、平板和手机。采用响应式设计，无论使用什么设备都能获得流畅舒适的阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '如何找到我想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过顶部的搜索框直接搜索漫画名称或作者，也可以通过分类导航浏览不同类型的漫画。我们还提供了排行榜和热门推荐。',
        },
      },
      {
        '@type': 'Question',
        name: '遇到阅读问题怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '如果您在使用过程中遇到任何问题，请通过联系方式与我们取得联系。我们的客服团队会在24小时内为您解决。',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://hahamanhua.com' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://hahamanhua.com/about' },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50 pt-16">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <div className="bg-white border-b border-foreground-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-2" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </nav>
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4">关于哈哈漫画网</h1>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            专注韩国漫画在线阅读，致力于为全球华语读者提供最优质的漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          <div>
            <div className="rounded-xl overflow-hidden h-80 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20creative%20office%20space%20with%20Korean%20manhwa%20comic%20artwork%20on%20walls%2C%20warm%20lighting%2C%20comfortable%20workspace%20with%20artists%20drawing%20tablets%2C%20creative%20studio%20atmosphere%2C%20inspirational%20vibe%2C%20clean%20modern%20design&width=800&height=600&seq=about-brand&orientation=landscape"
                alt="哈哈漫画网品牌形象"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex flex-col justify-center">
            <h2 className="text-2xl font-bold text-foreground-900 mb-4">品牌故事</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              哈哈漫画网成立于2020年，是韩国漫画领域的专业在线阅读平台。我们的团队由一群热爱漫画的年轻人组成，致力于打破语言和地域的壁垒，将优质的韩国漫画作品带给全球华语读者。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              经过多年的发展，哈哈漫画网已经与韩国多家知名漫画平台建立了深度合作关系。我们不仅提供海量的漫画资源，更注重阅读体验的优化——从高清画质到流畅的翻页体验，每一个细节都倾注了我们的心血。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              目前，哈哈漫画网已收录超过 <strong className="text-primary-600">{comics.length * 200}+</strong> 部漫画作品，涵盖恋爱、动作、奇幻、悬疑、搞笑等多种类型，日均活跃读者超过 <strong className="text-primary-600">50万</strong> 人。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {[
            { number: '3000+', label: '漫画作品', icon: 'ri-book-read-line' },
            { number: '50万+', label: '日均读者', icon: 'ri-user-heart-line' },
            { number: '99.9%', label: '服务可用率', icon: 'ri-cloud-line' },
            { number: '4.9', label: '用户评分', icon: 'ri-star-line' },
          ].map((stat, idx) => (
            <div key={idx} className="bg-white rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-primary-600`}></i>
              </div>
              <p className="text-2xl font-bold text-foreground-900">{stat.number}</p>
              <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mb-16">
          <h2 className="text-2xl font-bold text-foreground-900 text-center mb-8">用户口碑</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                name: '小雅',
                text: '哈哈漫画的画质真的没话说，比很多其他平台清晰多了！而且更新速度很快，我的追更体验非常好。',
                rating: 5,
              },
              {
                name: '动漫达人阿杰',
                text: '作为一个看了十年漫画的老读者，哈哈漫画的分类和推荐算法真的很精准，总能找到我喜欢的新作品。',
                rating: 5,
              },
              {
                name: '莉莉安',
                text: '最喜欢哈哈漫画的夜间模式，晚上窝在被窝里看漫画太舒服了。而且没有烦人的广告弹窗！',
                rating: 5,
              },
              {
                name: '漫画控小王',
                text: '界面简洁大方，加载速度快。关键是漫画资源真的很多，很多冷门的好作品也能在这里找到。',
                rating: 5,
              },
              {
                name: '苏菲的世界',
                text: '已经推荐给身边所有喜欢看漫画的朋友了！客服小姐姐的响应也很快，有问题随时能解决。',
                rating: 4,
              },
              {
                name: '追更小能手',
                text: '每日更新通知功能太贴心了，再也不用每天手动刷了。哈哈漫画真的是用心在做产品！',
                rating: 5,
              },
            ].map((review, idx) => (
              <div key={idx} className="bg-white rounded-xl p-6">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }, (_, i) => (
                    <i key={i} className={`ri-star-fill text-sm ${i < review.rating ? 'text-amber-500' : 'text-foreground-200'}`}></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;{review.text}&rdquo;
                </p>
                <p className="text-xs font-semibold text-foreground-900">{review.name}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-2xl font-bold text-foreground-900 text-center mb-8">常见问题</h2>
          <div className="max-w-3xl mx-auto space-y-3">
            {[
              { q: '哈哈漫画网的漫画是免费的吗？', a: '是的！哈哈漫画网上的所有漫画均可免费在线阅读，无需付费订阅。我们通过广告和会员增值服务维持运营，确保核心阅读功能对所有人开放。' },
              { q: '漫画的更新频率是怎样的？', a: '热门连载漫画通常每周更新一到两话，具体更新频率取决于韩国原作者的更新进度。我们会在漫画更新后的第一时间同步到平台，您可以通过"最近更新"栏目查看最新内容。' },
              { q: '支持哪些设备阅读？', a: '哈哈漫画网支持全平台阅读，包括PC电脑、平板和手机。我们采用响应式设计，无论使用什么设备，都能获得流畅舒适的阅读体验。' },
              { q: '如何找到我想看的漫画？', a: '您可以通过顶部的搜索框直接搜索漫画名称或作者，也可以通过分类导航浏览不同类型的漫画。我们还提供了排行榜和热门推荐，帮助您发现好看的漫画。' },
              { q: '遇到阅读问题怎么办？', a: '如果您在使用过程中遇到任何问题，请通过下方的联系方式与我们取得联系。我们的客服团队会在24小时内为您解决。' },
            ].map((faq, idx) => (
              <details key={idx} className="group bg-white rounded-xl overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors">
                  <span className="text-sm font-semibold text-foreground-900">{faq.q}</span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>

        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold text-foreground-900 text-center mb-8">联系我们</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <div className="bg-white rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">邮箱</h3>
              <p className="text-xs text-foreground-500">contact@hahamanhua.com</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-map-pin-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">地址</h3>
              <p className="text-xs text-foreground-500">韩国首尔市江南区</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-customer-service-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服</h3>
              <p className="text-xs text-foreground-500">工作日 9:00-18:00 (KST)</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}